export const ON_LOAD_PAYMENTS = "ON_LOAD_PAYMENTS";
export const ON_LOAD_PAYMENTS_SUCCESS = "ON_LOAD_PAYMENTS_SUCCESS";
export const SET_PAYMENTS_SORT = "SET_PAYMENTS_SORT";
export const OPEN_PAYMENT_FORM = "OPEN_PAYMENT_FORM";
export const SET_PAYMENTS_LIST_DATE_RANGE = "SET_PAYMENTS_LIST_DATE_RANGE";
